import {CREATE_ASSIGNMENT_LOG, GET_CREATE_ASSIGNMENT_LOG, LogCreate } from "../../../Model/Log"

const initState: LogCreate = {
    ResultDtoCreate: null,
    LogCreate: null,
}
//const dispatch = useDispatch();


export const AssignmentLogCreateReducer = (state = initState, action: { type: string, payload: LogCreate }) => {
    switch (action.type) {
        case CREATE_ASSIGNMENT_LOG:
            {
                return { ...state, ResultDtoCreate: action.payload.ResultDtoCreate }
            }
        case GET_CREATE_ASSIGNMENT_LOG:
            return { ...state, LogDtoCreate: action.payload.LogCreate }
        default:
            return state;
    }
}